"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _LoadingErrorPage = _interopRequireDefault(require("./LoadingErrorPage"));

var LoadingWrapper = function LoadingWrapper(_ref) {
  var ErrorComponent = _ref.ErrorComponent,
      children = _ref.children,
      requestStatus = _ref.requestStatus;

  if (requestStatus === _RequestStatusTypes.default.SUCCEEDED) {
    return children;
  } else if (requestStatus === _RequestStatusTypes.default.UNINITIALIZED || requestStatus === _RequestStatusTypes.default.PENDING) {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 300
    });
  }

  return _react.default.createElement(ErrorComponent, null);
};

LoadingWrapper.propTypes = {
  ErrorComponent: _react.PropTypes.func,
  children: _react.PropTypes.node.isRequired,
  requestStatus: _react.PropTypes.string.isRequired
};
LoadingWrapper.defaultProps = {
  ErrorComponent: _LoadingErrorPage.default
};
var _default = LoadingWrapper;
exports.default = _default;
module.exports = exports.default;